module.exports = {
    "collectionLabel": `Sugest\xf5es`
};


//# sourceMappingURL=pt-BR.main.js.map
